import { useVirtualizer } from '@tanstack/react-virtual';
import React, { useCallback } from 'react';
import { DataTable } from './DataTable';
export function VirtualizedDataTable({ table, tableContainerRef, overscan = 10, estimateSize, isLoading, withStickyHeader, getItemKey, }) {
    const { rows } = table.getRowModel();
    const virtualizer = useVirtualizer({
        count: rows.length,
        getScrollElement: useCallback(() => tableContainerRef.current, []),
        estimateSize: useCallback(() => estimateSize, [estimateSize]),
        getItemKey,
        overscan,
    });
    const virtualRows = virtualizer.getVirtualItems();
    const [paddingTop, paddingBottom] = virtualRows.length > 0
        ? [
            (virtualRows[0].start || 0) - virtualizer.options.scrollMargin,
            virtualizer.getTotalSize() -
                (virtualRows[virtualRows.length - 1].end || 0),
        ]
        : [0, 0];
    const getRows = useCallback(() => virtualRows.map((virtualRow) => rows[virtualRow.index]), [rows, virtualRows]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DataTable, { table: table, getRows: getRows, paddingTop: paddingTop, paddingBottom: paddingBottom, withStickyHeader: withStickyHeader, isLoading: isLoading }),
        React.createElement("div", { className: "fixed bottom-0 left-0 bg-gray-800 p-4 text-white", style: {
                zIndex: 1000,
            } },
            React.createElement("div", null,
                rows.length,
                " items fetched"),
            React.createElement("div", null,
                virtualRows.length,
                " virtual rows"))));
}
